import { Injectable } from '@angular/core';
import { ApiService } from './api.base.service';
import { NotificationModel } from "../../models/notification-model";
import { SignatureResponse } from '../../models/signature-response';
import { GetContent } from '../../models/get-content';
import { IWService } from '../iw.service';
import { SDKOperationRequest } from '@extrimian/identity-wallet';
import { SignContent } from '../../models/sign-content';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    baseUrl = "api/notification";

    constructor(private apiService: ApiService, private iwService: IWService) { }

    public async notify(
        inviteIds: string,
        notificationType: Number
    ): Promise<NotificationModel> {
        let notifyResponse = await this.apiService.post<NotificationModel>(
            `${this.baseUrl}/notify/${inviteIds}/${notificationType}`
        );

        return notifyResponse;
    }
}